import React from 'react';

import Title from './title';

function SectionTitle(props) {
  return <Title fontSizeMedium {...props} />;
}

export default SectionTitle;
